import React, { useState } from "react";
import { Col, Row, Badge, Button, Modal } from "react-bootstrap";

import SplitNumber from "../../../components/SplitNumber";
import _ from "lodash";

function WithdrowItem(props) {
  // let variantColor = "secondary";
  // if (props.ItemStatusType == true)
  //     variantColor = "success";
  // else if (props.ItemStatusType == false)
  //     variantColor = "danger";
  const setColor = (type) => {
    switch (type) {
      case "جدید":
        return "text-primary";
      case "رد_شده":
        return "text-danger";
      case "انجام_شد":
        return "text-success";
      case "درحال_پیگیری":
        return "text-warning";
      default:
        return "text-dark";
    }
  };

  const [showModalDescription, setShowModalDescription] = useState(false);
  const handleShowModalDescription = () => setShowModalDescription(true);
  const handleCloseModalDescription = () => setShowModalDescription(false);
  return (
    <>
      <Col xs={12} lg={4} className="mt-3 mt-md-2 px-1">
        <div className="bg-white border rounded-4 p-3 h-100">
          <Row>
            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">مبلغ :</span>
              <span className="fw-bold">
                {" "}
                <SplitNumber number={props.ItemPrice} />
              </span>{" "}
              تومان
            </Col>
            <Col xs={12} sm={6} lg={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">شماره کارت :</span>
              <span> {props.accountInfo} </span>
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={12}
              className="pb-2 px-2 text-sm-end text-lg-start"
            >
              <span className="fs-085 text-muted">نام بانک :</span>
              <span> {props.bankName} </span>
            </Col>

            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">صاحب حساب :</span>
              <span> {props.fullName} </span>
            </Col>

            <Col xs={12} className="px-2">
              <div className="text-dark pt-2 mt-1 border-dashed-top"></div>
            </Col>

            <Col xs={12} className=" px-2 my-1">
              <span className="fs-085 text-muted">وضعیت : </span>
              <span
                className={`fw-bold  fs-085  ${setColor(props.ItemStatus)}`}
              >
                {props.ItemStatus}
              </span>
            </Col>
            {!_.isEmpty(props.ItemDate) ? (
              <Col xs={12} className="pb-2 px-2 ">
                <span className="fs-085 text-muted">تاریخ : </span>
                <span>{props.ItemDate}</span>
              </Col>
            ) : (
              <></>
            )}
            {!_.isEmpty(props.ItemCode) ? (
              <Col xs={12} className="pb-2 px-2 ">
                <span className="fs-085 text-muted">کد پیگیری : </span>
                <span>{props.ItemCode}</span>
              </Col>
            ) : (
              <></>
            )}
            {!_.isEmpty(props.ItemDescription) ? (
              <Col xs={12} className="px-2 mt-2">
                <Button
                  variant="outline-primary"
                  className="fs-08 btn-sm rounded-2"
                  onClick={handleShowModalDescription}
                >
                  مشاهده بیشتر
                </Button>
                {/* <span className="fs-085 text-muted">توضیحات : </span>
              <span>{props.ItemDescription}</span> */}
              </Col>
            ) : (
              <></>
            )}
          </Row>
        </div>
      </Col>
      <Modal show={showModalDescription} onHide={handleCloseModalDescription}>
        <Modal.Header closeButton>
          <Modal.Title>درخواست برداشت وجه</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">مبلغ :</span>
              <span className="fw-bold">
                {" "}
                <SplitNumber number={props.ItemPrice} />
              </span>{" "}
              تومان
            </Col>
            <Col xs={12} sm={6} lg={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">شماره کارت :</span>
              <span> {props.accountInfo} </span>
            </Col>
            <Col
              xs={12}
              sm={6}
              lg={12}
              className="pb-2 px-2 text-sm-end text-lg-start"
            >
              <span className="fs-085 text-muted">نام بانک :</span>
              <span> {props.bankName} </span>
            </Col>

            <Col xs={12} className="pb-2 px-2">
              <span className="fs-085 text-muted">صاحب حساب :</span>
              <span> {props.fullName} </span>
            </Col>

            <Col xs={12} className="px-2">
              <div className="text-dark pt-2 mt-1 border-dashed-top"></div>
            </Col>

            <Col xs={12} className=" px-2 my-1">
              <span className="fs-085 text-muted">وضعیت : </span>
              <span
                className={`fw-bold  fs-085  ${setColor(props.ItemStatus)}`}
              >
                {props.ItemStatus}
              </span>
            </Col>
            {!_.isEmpty(props.ItemDate) && (
              <Col xs={12} className="pb-2 px-2 ">
                <span className="fs-085 text-muted">تاریخ : </span>
                <span>{props.ItemDate}</span>
              </Col>
            )}
            {!_.isEmpty(props.ItemCode) && (
              <Col xs={12} className="pb-2 px-2 ">
                <span className="fs-085 text-muted">کد پیگیری : </span>
                <span>{props.ItemCode}</span>
              </Col>
            )}
            {!_.isEmpty(props.ItemDescription) && (
              <Col xs={12} className="px-2">
                <span className="fs-085 text-muted">توضیحات : </span>
                <span>{props.ItemDescription}</span>
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className="btn-sm px-3"
            onClick={handleCloseModalDescription}
          >
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default WithdrowItem;
